package horcrux.frontend.common.views.org

import horcrux.frontend.common.configs.StaticContentConfigs
import mui.material.Container
import mui.system.PropsWithSx
import mui.system.sx
import react.FC
import react.dom.html.ReactHTML.img

external interface LogoProps : PropsWithSx {
    var widthMaybe: Double?
}

val Logo = FC<LogoProps> { props ->
    Container {
        this.sx {
            +props.sx
        }
        img {
            this.src = StaticContentConfigs.LOGO_PATH
            this.width = props.widthMaybe
        }
    }
}
